import React, { useRef, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import stars from "../../../assets/stars.png";
import scrollImg from "../../../assets/AmberSuiteImg/AS8.jpg";
import HoverButton from "../../HoverButton";
import EastIconArrow from "../../../assets/east.svg";
import { useNavigate } from "react-router-dom";

gsap.registerPlugin(ScrollTrigger);

const Content = () => {
  const navigate = useNavigate();

  return (
    <>
      <Box
        top={{ xs: "1%", sm: "1%", md: "1%", lg: 100 }}
        maxWidth={"372px"}
        left={{ xs: 24, lg: 150, xl: 150 }}
        position={"absolute"}
      >
        <Typography
          sx={{
            width: { xs: "200px", lg: "372px" },
            fontFamily: "'ZapfHumnst BT'",
            fontWeight: 400,
            whiteSpace: "normal",
            textTransform: "uppercase",
            wordBreak: "break-word",
            fontSize: { xs: "32px", lg: "74px" },
            lineHeight: { xs: "39.61px", lg: "91.6px" },
            letterSpacing: "0.03em",
            color: "#2A2A2A",
          }}
        >
          THE AMBER SUITE
        </Typography>
        <Typography
          sx={{
            maxWidth: "292px",
            fontFamily: "'Sora', sans-serif",
            fontSize: { xs: "12px", lg: "16px" },
            fontWeight: 300,
            lineHeight: { xs: "18px", lg: "22px" },
            letterSpacing: "1%",
            color: "#000000",
          }}
        >
          A warm, elegant space designed with golden hues and wooden accents.
        </Typography>
      </Box>
      <Box
        position={"absolute"}
        display={"flex"}
        flexDirection={{ xs: "column-reverse", lg: "column" }}
        gap={2}
        bottom={{ xs: 10, lg: 100 }}
        right={{ xs: 24, lg: 150, xl: 150 }}
        pl={3}
        width={293}
      >
        <HoverButton
          onClick={() => navigate("/the-earthen-suite")}
          width={"132px"}
          height={"50px"}
          endIcon={
            <img
              src={EastIconArrow}
              alt="east"
              style={{
                width: "25px",
                height: "25px",
                transform: "rotate(-50deg)",
              }}
            />
          }
          btnText={"Step in"}
          fillBgColor="#F3D991"
        />
        <Typography
          sx={{
            fontFamily: "'Sora', sans-serif",
            fontSize: { xs: "12px", lg: "16px" },
            fontWeight: 300,
            lineHeight: { xs: "18px", lg: "22px" },
            letterSpacing: "1%",
            color: "#000000",
          }}
        >
          Step into a cozy yet sophisticated retreat, where earthy tones and soft lighting create an inviting ambiance for a peaceful and luxurious stay.
          <br />
          <br />
          2000 sq. ft. • max. 4 guests
        </Typography>
      </Box>
    </>
  );
};

const ScrollAni2 = ({ circleColor }) => {
  // ------------------reference--------------------
  const mainContainer = useRef(null);
  const imgContainer = useRef(null);
  const contentRef = useRef(null);
  const squareRef = useRef(null);
  // ------------------reference--------------------

  // ------------------media-query --------------------
  // const isMediumScreen = useMediaQuery(
  //   "(min-width: 900px) and (max-width: 1199px)"
  // );
  // ------------------media-query --------------------


  // const radiusBreak = () => {
  //   switch (window.innerWidth) {
  //     case isMediumScreen:
  //       return 19;
  //   }
  // };

  // ------------------Animation-Logic--------------------
  useEffect(() => {
    const ctx = gsap.context(() => {
      const updateClipPath = (progress) => {
        const radius = 85 - progress * 70;
        const contentPosition = Math.max(
          -50,
          Math.min(100, (1 - progress) * 100)
        );

        if (radius >= 10) {
          imgContainer.current.style.clipPath = `circle(${radius}% at 50% 50%)`;
          imgContainer.current.style.WebkitClipPath = `circle(${radius}% at 50% 50%)`;

          contentRef.current.style.transform = `translateY(0px)`;
          contentRef.current.style.transform = `translateY(${contentPosition}px)`;
          console.log(radius, "-->" + contentPosition);
        }
        if (radius <= 20) {
          contentRef.current.style.transform = `translateY(${contentPosition}px)`;
          contentRef.current.style.opacity = 1;

          // contentRef.current.style.transform = `translateY(0px)`;

          contentRef.current.style.transition =
            "transform 0.5s ease-out, opacity 0.2s ease-out";
        } else {
          contentRef.current.style.opacity = 0;
        }
      };

      gsap.fromTo(
        imgContainer.current,
        {},
        {
          scrollTrigger: {
            trigger: mainContainer.current,
            start: "top top",
            end: "bottom bottom",
            scrub: true,
            pin: true,
            onUpdate: (self) => updateClipPath(self.progress),
          },
        }
      );
    }, mainContainer);
    setTimeout(() => ScrollTrigger.refresh(), 100);

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
      setTimeout(1);

      ctx.revert();
    };
  }, [circleColor]);
  // ------------------Animation-Logic--------------------

  return (
    <Box
      boxSizing={"border-box"}
      width="100%"
      bgcolor={"#FDEEB7"}
      height="130vh"
      ref={mainContainer}
      position={"relative"}
    >
      <Box
        ref={imgContainer}
        sx={{
          position: "absolute",
          width: "100%",
          height: "100vh",
          zIndex: 2,
          transition: "clip-path 0.8s ease-out",
          clipPath: "circle(100% at 50% 50%)",
          overflow: "hidden",
        }}
      >
        <img
          src={`${scrollImg}`}
          alt="scroll animation"
          style={{ width: "100%", height: "100vh", objectFit: "cover" }}
        />
      </Box>

      <Box
        ref={squareRef}
        sx={{
          position: "absolute",
          bottom: "54%",
          left: "40%",
          width: "200px",
          height: "200px",
          borderRadius: "50%",
          opacity: 0.7,
          backgroundColor: "#E8C36B",
          backgroundImage: `url(${stars})`,
          zIndex: 1,
        }}
      />
      <Box
        ref={contentRef}
        sx={{
          opacity: 0,
          position: "absolute",
          minWidth: "400px",
          top: 0,
          transform: "translateY(50px)",
          height: "100vh",
          width: "100%",
          transition: "transform 0.5s ease-out, opacity 0.2s ease-out",
        }}
      >
        <Content />
      </Box>
    </Box>
  );
};

export default ScrollAni2;
